// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addBtn[data-v-34433436] {\n  margin-bottom: 20px;\n}\n.divBox .el-pagination[data-v-34433436] {\n  padding-bottom: 20px;\n}", ""]);
// Exports
module.exports = exports;
